import React from 'react';
import isEmpty from 'lodash/isEmpty';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ValidatedTextInput } from '@els/els-react--text-input';
import MultiInputPill from './MultiInputPill';

import './MultiInput.scss';

function MultiInput({
  values,
  multiInputOnRemove,
  createdRef,
  inputValue,
  inputOnChange,
  validationMessage,
  description,
  className,
  placeholder,
  disabled = false,
  additionDisabled = false,
  ...otherInputProps
}) {
  const handleInputChange = (event) => {
    inputOnChange(event?.target?.value ?? '');
  };

  return (
    <div className="els-multi-input-container">
      <fieldset className={classnames(['els-multi-input-wrapper', { disabled }])} ref={createdRef}>
        <legend className="sr-only">Email addresses</legend>
        <ul className="els-multi-input-pills" aria-label="Selected email addresses">
          {!isEmpty(values) &&
            values.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={index}>
                <MultiInputPill value={item.value} onRemove={() => multiInputOnRemove(index)} disabled={item.disabled || disabled} />
              </li>
            ))}
        </ul>
        <ValidatedTextInput
          id="id-multi-input-input"
          data-e2e="multi-input-text-input"
          className={classnames(['els-multi-input-input', className])}
          value={inputValue}
          onChange={handleInputChange}
          validator="email"
          placeholder={isEmpty(values) ? placeholder : 'Add another email'}
          disabled={disabled || additionDisabled}
          label={description || placeholder}
          shouldHideLabel
          {...otherInputProps}
        />
      </fieldset>
      <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
        {validationMessage || ''}
      </div>
    </div>
  );
}

MultiInput.propTypes = {
  // props
  values: PropTypes.array,
  multiInputOnRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  additionDisabled: PropTypes.bool,

  // HOCs
  createdRef: PropTypes.object.isRequired, // withCreatedRef HOC
  inputValue: PropTypes.string, // withMultiInputStateHandlers HOC
  inputOnChange: PropTypes.func.isRequired, // withInputValueOnChange HOC
  validationMessage: PropTypes.string, // withMultiInputStateHandlers HOC

  // Input props
  className: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
};

export default React.memo(MultiInput);
